<template>
    <div class="main-body">
        <h2>{{ $strings('spsite/cp/title') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
                <el-button size="small" type="primary" @click="onCreate">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter-wrapper">
                <el-button @click="onRefresh" size="small" :loading="refreshing">{{
                        $strings('word/refresh')
                    }}
                </el-button>
            </div>
        </div>
        <br>
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column prop="smpp_host" :label="$strings('word/smpp_host')">
                    <template slot-scope="scope"><span>{{ scope.row.smpp_host }}</span></template>
                </el-table-column>
                <el-table-column prop="smpp_port" :label="$strings('word/smpp_port')"></el-table-column>
                <el-table-column prop="link_id" :label="$strings('word/link_id')"></el-table-column>
                <el-table-column prop="cp_app_id" :label="$strings('word/cp_app_id')" width="156">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.cp_app_id">{{ scope.row.cp_app_id }}</span>
                        <el-link v-else type="primary" @click="goCpApp(scope.row.cp_app_id)" class="code-text">
                            {{ scope.row.cp_app_id }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="is_lock" :label="$strings('word/is_lock')" width="80">
                    <template slot-scope="scope">
                        <i class="el-icon-lock" v-if="scope.row.is_lock*1>0"></i>
                    </template>
                </el-table-column>
                <el-table-column prop="online" :label="$strings('word/online')">
                    <template slot-scope="scope">
                        <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.online"
                                   @change="onSwitchOnline(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="Remark" width="180"></el-table-column>
                <el-table-column label="Edit" width="160">
                    <template slot-scope="scope">
                        <el-button size="small" @click="onEdit(scope.row)">Edit</el-button>
                        <el-button size="small" @click="onCopy(scope.row)">Copy</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination margin-top-1" v-if="pagination.total > pagination.size" style="text-align: right">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page" @current-change="refreshData"></el-pagination>
            </div>
        </div>
        <el-dialog
            :title="mode === 'create' ? $strings('word/create') : $strings('word/edit')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="editForm" label-width="80px" :rules="rules">
                    <el-form-item :label="$strings('word/status')" prop="online">
                        <el-select v-model="editForm.online"
                                   filterable>
                            <el-option :label="$strings('word/online')" :value="nodeStatus.ONLINE"></el-option>
                            <el-option :label="$strings('word/offline')" :value="nodeStatus.OFFLINE"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$strings('word/smpp_host')" prop="smpp_host" v-if="mode!=='edit'">
                        <el-input v-model="editForm.smpp_host" clearable maxlength="16" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('word/smpp_port')" prop="smpp_port" v-if="mode!=='edit'">
                        <el-input v-model="editForm.smpp_port" clearable maxlength="5" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('word/remark')" prop="remark">
                        <el-input v-model="editForm.remark" clearable maxlength="16" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('word/is_lock')" prop="is_lock">
                        <el-switch :active-value="1" :inactive-value="0" v-model="editForm.is_lock"></el-switch>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSaveEdit()" :loading="saving">{{ $strings('word/confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {NODE_STATUS,} from "@/config/config";
import {SpSiteSmppNodeCreate, SpSiteSmppNodeRead, SpSiteSmppNodeUpdate} from "@/api/spsite/api";
import {API_STATUS_CODE} from "@/config/config";

export default {
    name: "spsite-smpp-node",
    data() {
        return {
            loading: true,
            refreshing: false,
            saving: false,
            editForm: {},
            formFilter: {},
            tableData: [],
            dialogVisible: false,
            pagination: {
                total: 0,
                page: 1,
                size: 12,
            },
            nodeStatus: NODE_STATUS,
            rules: {
                remark: [
                    {required: true, message: this.$strings('spsite/cp/error/remark_empty'), trigger: 'blur'}
                ],
                smpp_host: [
                    {required: true, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'},
                    {min: 3, max: 16, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'}
                ],
                smpp_port: [
                    {required: true, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'},
                    {min: 3, max: 8, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'}
                ],
                online: [
                    {required: true, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'},
                    {min: 1, max: 2, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'}
                ]
            },
            mode: 'create'
        }
    },
    mounted() {
        this.refreshData();
    },
    computed: {},
    methods: {
        goCpApp(app_id) {
            this.$router.push('/spsite/cpapp/' + app_id);
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onEdit(row) {
            this.mode = 'edit';
            this.editForm = row;
            this.dialogVisible = true;
        },
        onCopy(row) {
            this.mode = 'copy';
            this.editForm = JSON.parse(JSON.stringify(row));
            this.editForm.lock = 0;
            this.editForm.link_id = '';
            this.editForm.cp_app_id = '';
            this.dialogVisible = true;
        },
        onCreate() {
            this.mode = 'create';
            this.editForm = {};
            this.dialogVisible = true;
        },
        onSwitchOnline(row) {
            this.editForm = row;
            this.onSaveEdit();
        },
        onSaveEdit() {
            this.saving = true;
            this.editForm.online = 1 * this.editForm.online;
            this.editForm.smpp_port = 1 * this.editForm.smpp_port;
            let action = this.mode === 'edit' ? SpSiteSmppNodeUpdate : SpSiteSmppNodeCreate;
            action(this.editForm).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.dialogVisible = false;
                    this.refreshData();
                    this.onRefresh();
                }
            }).finally(() => {
                this.loading = false;
                this.saving = false;
            });
        },
        refreshData() {
            this.loading = true;
            this.formFilter.size = this.pagination.size;
            this.formFilter.page = this.pagination.page;
            this.formFilter.is_lock = 1;
            SpSiteSmppNodeRead(this.formFilter).then((resp) => {
                this.tableData = resp.data.data.count > 0 ? resp.data.data.rows : [];
                this.pagination.total = resp.data.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        onRefresh() {
            this.refreshData();
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>